import { en } from './en'
import { fr } from './fr'

export const referralPage = {
  en,
  fr
}